export function FeedIcon(props) {
  const { icon, iconAlt, ...imgAttrs } = props;
  const icons = {
    "update": "https://wvusstatic.com/mywv/msc/feed/feed-update-icon.svg",
    "letter": "https://wvusstatic.com/mywv/msc/feed/letter-icon.svg",
    "prayer": "https://wvusstatic.com/mywv/msc/feed/prayer-icon.svg",
    "photo": "https://wvusstatic.com/mywv/msc/feed/photo-media-icon.svg",
    "video": "https://wvusstatic.com/mywv/msc/feed/video-media-icon.svg",
    "birthday": "https://wvusstatic.com/mywv/msc/feed/feed-birthday-icon.svg",
    "loveofgodandneighbors": "https://wvusstatic.com/mywv/msc/feed/bible.svg",
    "childprotectionandcare": "https://wvusstatic.com/mywv/msc/feed/child-smiling.svg",
    "educationforbetterlives": "https://wvusstatic.com/mywv/msc/feed/calculator-protractor.svg",
    "healthychildrenandfamilies": "https://wvusstatic.com/mywv/msc/feed/ambulance.svg",
    "health,waterandnutrition": "https://wvusstatic.com/mywv/msc/feed/ambulance.svg",
    "app": "https://wvusstatic.com/mywv/msc/feed/app-icon.svg"
  };

  const selectedIcon = icons[icon] || icons.update;

  return (
    <img 
      {...imgAttrs}
      className={`feed-icon feed-icon__${icon} ${imgAttrs.className ? imgAttrs.className : ""}`} 
      src={selectedIcon} 
      alt={iconAlt}
    />
  )
}

export default FeedIcon;